/**
 * Created by jv on 25/05/2018.
 */
import CONSTANTS from "Sources/games/carrot-game/config/constants";
import getText from "Sources/games/carrot-game/config/text";
let Text;

export default class GameOver extends Phaser.Scene
{
  constructor()
  {
    super({
      key: "GameOver",
    });
  }

  init({ gameScene })
  {
    Text = getText();

    this.gameScene = gameScene;
    this.gameScene.events.off("game-end").on("game-end", function()
    {
      this.setHighScore();
      this.setVisible(true);
    }, this);

    this.scene.setVisible(false);
  }

  create()
  {
    var gameWidth = this.sys.game.config.width;
    var gameHeight = this.sys.game.config.height;

    this.backdrop = this.add.image(0, 0, "bg_overlay").setOrigin(0, 0);

    this.add.text(gameWidth / 2, gameHeight / 4, Text.gameOver.title, { fontFamily: "RabbitOnTheMoon", fontSize: 48, fontWeight: "normal", fill: "#FFFFFF" }).setOrigin(0.5);

    this.highScoreLabel = this.add.text(gameWidth / 2, gameHeight / 2, "", { fontFamily: "RabbitOnTheMoon", fontSize: 36, fontWeight: "normal", fill: "#FFFFFF" }).setOrigin(0.5).setPadding({ right: 10 });
    this.highScoreLabelImage = this.add.image(this.highScoreLabel.x + this.highScoreLabel.width + 5, this.highScoreLabel.y - 10, CONSTANTS.ATLAS_KEY, "consumables/consumable_carrot.png").setOrigin(0, 0.5);

    const buttonImageHeight = this.scene.systems.game.textures.getFrame(CONSTANTS.ATLAS_KEY, "misc/image_button.png").realHeight;
    const buttonImage = this.add.image(gameWidth / 2, gameHeight - buttonImageHeight * 1.5, CONSTANTS.ATLAS_KEY, "misc/image_button.png").setOrigin(0.5, 1);
    const restartIconWidth = this.scene.systems.game.textures.getFrame(CONSTANTS.ATLAS_KEY, "misc/icon_restart.png").realWidth;
    const startButtonText = this.add.text(buttonImage.x + restartIconWidth, buttonImage.y - buttonImage.height / 2, Text.gameOver.replayBtn, { fontFamily: "AbadiMTPro-CondExtraBold", fontSize: 18, fill: "#ffffff" }).setOrigin(0.5).setPadding({ left: 15 });
    this.add.image(startButtonText.x - startButtonText.width / 2, startButtonText.y, CONSTANTS.ATLAS_KEY, "misc/icon_restart.png").setOrigin(1, 0.5);

    this.replayBtnZone = this.add.zone(
      buttonImage.x - (buttonImage.width * buttonImage.originX) - 5,
      buttonImage.y - (buttonImage.height * buttonImage.originY) - 5,
      buttonImage.width + 10,
      buttonImage.height + 10
    )
      .setName("replay-button")
      .once("pointerup", () =>
      {
        this.input.mouse.target.style.cursor = "";
        this.gameScene.restart();
      }, this)
      .on("pointerover", (e) =>
      {
        this.input.mouse.target.style.cursor = "pointer";
      })
      .on("pointerout", (e) =>
      {
        this.input.mouse.target.style.cursor = "";
      });
  }

  setHighScore()
  {
    var highScoreText = Text.gameOver.highScore + this.gameScene.highScore;
    this.highScoreLabel.setText(highScoreText);
    this.highScoreLabelImage.x = this.highScoreLabel.x + (this.highScoreLabel.width / 2);
  }

  setVisible(flag)
  {
    if(flag)
    {
      this.replayBtnZone.setInteractive();
    }
    else
    {
      this.replayBtnZone.removeInteractive();
    }

    this.scene.setVisible(flag);
  }
}



// WEBPACK FOOTER //
// ./app/js/games/carrot-game/scenes/game-over.js